// extracted by mini-css-extract-plugin
module.exports = {"savedButton":"styles_savedButton__nXREM","icon":"styles_icon__HKWCd","savedButtonWrapper":"styles_savedButtonWrapper__JUYKS","flashingDot_1":"styles_flashingDot_1__VhkvD","flashDot1":"styles_flashDot1__1lBNL","flashingDot_2":"styles_flashingDot_2__Kkhl0","flashDot2":"styles_flashDot2__GBGmN"};
module.exports.__checksum = "ea52b97c4d5c"
